import { takeLatest } from 'redux-saga/effects';

import { ArticleFields, IArticle } from '@pressreader/content-types';
import { openPopup } from '@pressreader/popups-core';
import { hasFlag } from '@pressreader/utils';

import { initArticleCopyDialog } from '../../components/dialog';
import { createTextCopyArticleViewModel } from '../../utils';
import { openCopyArticleDialogAction } from '../actions';
import { loadFullArticle } from '../saga.utils';

const copyArticleRequiredFields =
    ArticleFields.Issue | ArticleFields.Images | ArticleFields.Paragraphs | ArticleFields.Paragraphs | ArticleFields.Publication;

function* openCopyArticleDialog({ payload }: ReturnType<typeof openCopyArticleDialogAction>) {
    const { article } = payload as { article: IArticle };
    let fullContentArticle = article;

    if (!hasFlag(fullContentArticle.availableFields ?? ArticleFields.None, copyArticleRequiredFields)) {
        fullContentArticle =
            (yield* loadFullArticle(fullContentArticle.id, {
                lang: article.language,
            })) ?? fullContentArticle;
    }

    const articleTextViewModel = createTextCopyArticleViewModel(fullContentArticle);

    const { name } = initArticleCopyDialog();
    yield* openPopup({
        type: 'dialog',
        name,
        supportNativeScroll: true,
        options: { model: articleTextViewModel },
    });
}

export function* saga() {
    yield takeLatest(openCopyArticleDialogAction, openCopyArticleDialog);
}
